import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, vModelText as _vModelText, normalizeClass as _normalizeClass, vModelSelect as _vModelSelect, resolveDirective as _resolveDirective } from "vue"

const _hoisted_1 = {
  id: "InfoRequest",
  class: "container"
}
const _hoisted_2 = ["aria-label"]
const _hoisted_3 = { class: "inforequest inner" }
const _hoisted_4 = {
  key: 0,
  class: "request"
}
const _hoisted_5 = ["disabled"]
const _hoisted_6 = {
  class: "maintitle s36 mrg",
  "data-mrgb": "30"
}
const _hoisted_7 = {
  class: "cta mrg",
  "data-mrgb": "30"
}
const _hoisted_8 = ["href"]
const _hoisted_9 = { class: "item event-option-list" }
const _hoisted_10 = { class: "checkbox event-option" }
const _hoisted_11 = { for: "OnlyExhibition" }
const _hoisted_12 = { class: "maintitle" }
const _hoisted_13 = { class: "maintitle" }
const _hoisted_14 = ["aria-label", "id", "value"]
const _hoisted_15 = ["for"]
const _hoisted_16 = { class: "maintitle" }
const _hoisted_17 = {
  key: 1,
  class: "formimage"
}
const _hoisted_18 = {
  class: "form",
  "data-request": ""
}
const _hoisted_19 = ["disabled"]
const _hoisted_20 = {
  key: 0,
  class: "maintitle s60"
}
const _hoisted_21 = {
  key: 1,
  class: "maintitle s60"
}
const _hoisted_22 = { class: "group" }
const _hoisted_23 = { class: "item" }
const _hoisted_24 = { for: "NameSurname" }
const _hoisted_25 = ["placeholder"]
const _hoisted_26 = { class: "item" }
const _hoisted_27 = ["placeholder"]
const _hoisted_28 = { class: "group" }
const _hoisted_29 = { class: "item" }
const _hoisted_30 = { for: "Company" }
const _hoisted_31 = ["aria-label", "placeholder"]
const _hoisted_32 = { class: "item" }
const _hoisted_33 = ["value"]
const _hoisted_34 = { class: "item" }
const _hoisted_35 = { for: "Country" }
const _hoisted_36 = ["aria-label", "placeholder"]
const _hoisted_37 = { class: "group" }
const _hoisted_38 = { class: "item" }
const _hoisted_39 = { for: "Phone" }
const _hoisted_40 = ["aria-label", "placeholder"]
const _hoisted_41 = { class: "item" }
const _hoisted_42 = ["aria-label", "placeholder"]
const _hoisted_43 = ["disabled"]
const _hoisted_44 = ["innerHTML"]
const _hoisted_45 = { class: "item" }
const _hoisted_46 = { class: "checkbox" }
const _hoisted_47 = { for: "IsMarketingPolicy" }
const _hoisted_48 = ["disabled"]
const _hoisted_49 = {
  key: 0,
  class: "validation-summary-errors"
}
const _hoisted_50 = { class: "cta" }
const _hoisted_51 = ["innerHTML"]
const _hoisted_52 = {
  key: 1,
  class: "request"
}
const _hoisted_53 = {
  key: 0,
  class: "formimage align-items-center"
}
const _hoisted_54 = { class: "form" }
const _hoisted_55 = { class: "maintitle s60" }
const _hoisted_56 = { class: "cta s16" }

import { ref, onMounted, watch, computed } from "vue";
import { useStore } from "vuex";
import Axios from "axios";
import Localizer from "@Scripts/Common/Localizer";
import FormHelper from "@Scripts/Common/FormHelper";
import GTagHelper from "@Scripts/Infrastructure/GTagHelper";


export default /*@__PURE__*/_defineComponent({
  __name: 'InfoRequest',
  props: {
    recaptchaSiteKey: {},
    titleForm: {},
    landingName: {}
  },
  setup(__props: any) {

const props = __props;

const store = useStore();
const localizer = Localizer;
const routes = (window as any).App.routes;

const isLoading = ref(true);
const isLoadingForm = ref(false);
const isSuccess = ref(false);
const formData = ref<any>({
    events: [],
    profession: null,
    isMarketingPolicy: false
});
const events = ref<any[]>([]);
const professionalRoles = ref<any[]>([]);
const validationErrors = ref<any[]>([]);
const isQrCodeScan = ref(false);
const infoRequestModal = ref<HTMLElement | null>(null);

const isDialogVisible = computed(() => store.getters["infoRequestStore/isDialogVisible"]);

watch(isDialogVisible, (newValue) => {
    const url = new URL(window.location.href);
    if (newValue) {
        document.body.classList.add("overflow");
        infoRequestModal.value?.classList.add("show");
    } else {
        document.body.classList.remove("overflow");
        infoRequestModal.value?.classList.remove("show");
    }
    if (newValue) {
        if (!url.searchParams.has("isVisible")) {
            url.searchParams.append("isVisible", "true");
            window.history.pushState(window.history.state, document.title, url.toString());
        }
        return;
    }
    if (url.searchParams.has("isVisible")) {
        url.searchParams.delete("isVisible");
        window.history.pushState(window.history.state, document.title, url.toString());
        formData.value = { events: [], profession: null, isMarketingPolicy: false };
        isSuccess.value = false;
        validationErrors.value = [];
    }
});

onMounted(async () => {
    await getData();
    window.addEventListener("popstate", () => {
        store.commit("infoRequestStore/setIsDialogVisible", (new URL(window.location.href)).searchParams.has("isVisible"));
    });
    const url = new URL(window.location.href);
    if (url.searchParams.has("isVisible")) {
        store.commit("infoRequestStore/setIsDialogVisible", true);
    }
    if (url.searchParams.has("isQrCodeScan")) {
        store.commit("infoRequestStore/setIsDialogVisible", true);
        isQrCodeScan.value = true;
    }
});

async function getData() {
    const response = (await Axios.post(routes.LandingPage_LandingLightBuilding_GetSubscribeData)).data;
    events.value = response.events;
    professionalRoles.value = response.professionalRoles;
    isLoading.value = false;
}

function setEvents(e: any) {
    if (e.target.value === "OnlyExhibition") {
        formData.value.events = formData.value.events.length === 0 ? [events.value[0].value] : ["OnlyExhibition"];
    } else {
        formData.value.events = formData.value.events.length === 0 ? ["OnlyExhibition"] : formData.value.events.filter((x: any) => x !== "OnlyExhibition");
    }
}

async function submitForm() {
    FormHelper.removeFocus();
    validationErrors.value = [];
    isLoadingForm.value = true;
    formData.value.isQrCodeScan = isQrCodeScan.value;
    if (events.value.length === 0) {
        formData.value.events = ["OnlyExhibition"];
    }
    (window as any).grecaptcha.enterprise.ready(async () => {
        const token = await (window as any).grecaptcha.enterprise.execute(props.recaptchaSiteKey, { action: "Submit" });
        try {
            await Axios.post(routes.LandingPage_LandingLightBuilding_Submit, formData.value, { headers: { RecaptchaVerificationToken: token } });
            isSuccess.value = true;
            GTagHelper.sendEvent("form_submit", "landing_info_request", props.landingName);
        } catch (error: any) {
            if (error.response && error.response.status === 400) {
                validationErrors.value = FormHelper.getValidationErrors(error.response.data);
            }
        }
        isLoadingForm.value = false;
    });
}

function closeInfoRequest() {
    store.commit('infoRequestStore/setIsDialogVisible', false);
}

function isValidationError(controlName: string): boolean {
    return FormHelper.isControlValidationError(controlName, validationErrors.value);
}

return (_ctx: any,_cache: any) => {
  const _directive_close_dialog = _resolveDirective("close-dialog")!

  return _withDirectives((_openBlock(), _createElementBlock("div", {
    ref_key: "infoRequestModal",
    ref: infoRequestModal,
    class: "dialog full",
    role: "dialog"
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("button", {
        class: "close icon fastic-close",
        "aria-label": _unref(localizer).get('App.Common.Close'),
        onClick: closeInfoRequest
      }, null, 8, _hoisted_2),
      _createElementVNode("div", _hoisted_3, [
        (!isSuccess.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              (events.value.length !== 0)
                ? (_openBlock(), _createElementBlock("fieldset", {
                    key: 0,
                    disabled: isLoadingForm.value
                  }, [
                    _createElementVNode("h3", _hoisted_6, _toDisplayString(_unref(localizer).get("LandingPage.InfoRequest.SelectEvents")), 1),
                    _createElementVNode("div", _hoisted_7, [
                      _createElementVNode("a", {
                        href: _unref(routes).LandingPage_LandingPage_Detail,
                        class: "button secondary"
                      }, _toDisplayString(_unref(localizer).get("LandingPage.InfoRequest.GoToEventDetails")), 9, _hoisted_8)
                    ]),
                    _createElementVNode("div", _hoisted_9, [
                      _createElementVNode("div", _hoisted_10, [
                        _withDirectives(_createElementVNode("input", {
                          "aria-label": "OnlyExhibition",
                          type: "checkbox",
                          id: "OnlyExhibition",
                          value: "OnlyExhibition",
                          onChange: _cache[0] || (_cache[0] = ($event: any) => (setEvents($event))),
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formData.value.events) = $event))
                        }, null, 544), [
                          [_vModelCheckbox, formData.value.events]
                        ]),
                        _createElementVNode("label", _hoisted_11, [
                          (!isQrCodeScan.value)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                _createElementVNode("span", _hoisted_12, _toDisplayString(_unref(localizer).get("LandingPage.InfoRequest.OnlyExhibition_Title")), 1),
                                _createTextVNode(" " + _toDisplayString(_unref(localizer).get("LandingPage.InfoRequest.OnlyExhibition_Description")), 1)
                              ], 64))
                            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                _createElementVNode("span", _hoisted_13, _toDisplayString(_unref(localizer).get("LandingPage.InfoRequest.OnlyContact_Title")), 1),
                                _createTextVNode(" " + _toDisplayString(_unref(localizer).get("LandingPage.InfoRequest.OnlyContact_Description")), 1)
                              ], 64))
                        ])
                      ]),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(events.value, (item, index) => {
                        return (_openBlock(), _createElementBlock("div", {
                          class: "checkbox event-option",
                          key: index
                        }, [
                          _withDirectives(_createElementVNode("input", {
                            "aria-label": item.date,
                            type: "checkbox",
                            id: item.value,
                            value: item.value,
                            onChange: _cache[2] || (_cache[2] = ($event: any) => (setEvents($event))),
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((formData.value.events) = $event))
                          }, null, 40, _hoisted_14), [
                            [_vModelCheckbox, formData.value.events]
                          ]),
                          _createElementVNode("label", {
                            for: item.value
                          }, [
                            _createElementVNode("span", _hoisted_16, _toDisplayString(item.date), 1),
                            _createTextVNode(" " + _toDisplayString(item.description), 1)
                          ], 8, _hoisted_15)
                        ]))
                      }), 128))
                    ])
                  ], 8, _hoisted_5))
                : _createCommentVNode("", true),
              (!isLoading.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                    _createElementVNode("div", _hoisted_18, [
                      _createElementVNode("fieldset", { disabled: isLoadingForm.value }, [
                        (!isQrCodeScan.value)
                          ? (_openBlock(), _createElementBlock("h3", _hoisted_20, _toDisplayString(__props.titleForm), 1))
                          : (_openBlock(), _createElementBlock("h3", _hoisted_21, _toDisplayString(_unref(localizer).get("LandingPage.InfoRequest.QRCodeFormTitle")), 1)),
                        _createElementVNode("div", _hoisted_22, [
                          _createElementVNode("div", _hoisted_23, [
                            _createElementVNode("label", _hoisted_24, _toDisplayString(_unref(localizer).get("LandingPage.InfoRequest.NameSurname")), 1),
                            _withDirectives(_createElementVNode("input", {
                              type: "text",
                              id: "Name",
                              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((formData.value.name) = $event)),
                              placeholder: _unref(localizer).get('LandingPage.InfoRequest.NamePlaceholder'),
                              class: _normalizeClass([{ 'input-validation-error': isValidationError('Name') }, 'input w300'])
                            }, null, 10, _hoisted_25), [
                              [
                                _vModelText,
                                formData.value.name,
                                void 0,
                                { lazy: true }
                              ]
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_26, [
                            _withDirectives(_createElementVNode("input", {
                              type: "text",
                              id: "Surname",
                              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((formData.value.surname) = $event)),
                              placeholder: _unref(localizer).get('LandingPage.InfoRequest.SurnamePlaceholder'),
                              class: _normalizeClass([{ 'input-validation-error': isValidationError('Surname') }, 'input w300'])
                            }, null, 10, _hoisted_27), [
                              [
                                _vModelText,
                                formData.value.surname,
                                void 0,
                                { lazy: true }
                              ]
                            ])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_28, [
                          _createElementVNode("div", _hoisted_29, [
                            _createElementVNode("label", _hoisted_30, _toDisplayString(_unref(localizer).get("LandingPage.InfoRequest.CompanyAndProfession")), 1),
                            _withDirectives(_createElementVNode("input", {
                              type: "text",
                              "aria-label": _unref(localizer).get('LandingPage.InfoRequest.Company'),
                              id: "Company",
                              placeholder: _unref(localizer).get('LandingPage.InfoRequest.CompanyPlaceholder'),
                              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((formData.value.company) = $event)),
                              class: _normalizeClass([{ 'input-validation-error': isValidationError('Company') }, 'input w300'])
                            }, null, 10, _hoisted_31), [
                              [
                                _vModelText,
                                formData.value.company,
                                void 0,
                                { lazy: true }
                              ]
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_32, [
                            _withDirectives(_createElementVNode("select", {
                              id: "Profession",
                              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((formData.value.profession) = $event)),
                              class: _normalizeClass([{ 'input-validation-error': isValidationError('Profession') }, 'input w300'])
                            }, [
                              _cache[14] || (_cache[14] = _createElementVNode("option", { value: null }, "...", -1)),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(professionalRoles.value, (item, index) => {
                                return (_openBlock(), _createElementBlock("option", {
                                  value: item.value,
                                  key: index
                                }, _toDisplayString(item.title), 9, _hoisted_33))
                              }), 128))
                            ], 2), [
                              [_vModelSelect, formData.value.profession]
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_34, [
                            _createElementVNode("label", _hoisted_35, _toDisplayString(_unref(localizer).get("LandingPage.InfoRequest.Country")), 1),
                            _withDirectives(_createElementVNode("input", {
                              type: "text",
                              "aria-label": _unref(localizer).get('LandingPage.InfoRequest.Country'),
                              id: "Country",
                              placeholder: _unref(localizer).get('LandingPage.InfoRequest.CountryPlaceholder'),
                              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((formData.value.country) = $event)),
                              class: _normalizeClass([{ 'input-validation-error': isValidationError('Country') }, 'input w300'])
                            }, null, 10, _hoisted_36), [
                              [
                                _vModelText,
                                formData.value.country,
                                void 0,
                                { lazy: true }
                              ]
                            ])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_37, [
                          _createElementVNode("div", _hoisted_38, [
                            _createElementVNode("label", _hoisted_39, _toDisplayString(_unref(localizer).get("LandingPage.InfoRequest.PhoneEmail")), 1),
                            _withDirectives(_createElementVNode("input", {
                              type: "tel",
                              "aria-label": _unref(localizer).get('LandingPage.InfoRequest.Phone'),
                              id: "Phone",
                              placeholder: _unref(localizer).get('LandingPage.InfoRequest.PhonePlaceholder'),
                              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((formData.value.phone) = $event)),
                              class: _normalizeClass([{ 'input-validation-error': isValidationError('Phone') }, 'input w300'])
                            }, null, 10, _hoisted_40), [
                              [
                                _vModelText,
                                formData.value.phone,
                                void 0,
                                { lazy: true }
                              ]
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_41, [
                            _withDirectives(_createElementVNode("input", {
                              type: "email",
                              "aria-label": _unref(localizer).get('LandingPage.InfoRequest.Email'),
                              id: "Email",
                              placeholder: _unref(localizer).get('LandingPage.InfoRequest.EmailPlaceholder'),
                              "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((formData.value.email) = $event)),
                              class: _normalizeClass([{ 'input-validation-error': isValidationError('Email') }, 'input w300'])
                            }, null, 10, _hoisted_42), [
                              [
                                _vModelText,
                                formData.value.email,
                                void 0,
                                { lazy: true }
                              ]
                            ])
                          ])
                        ])
                      ], 8, _hoisted_19),
                      _createElementVNode("fieldset", { disabled: isLoadingForm.value }, [
                        _createElementVNode("div", {
                          class: "desc small",
                          innerHTML: _unref(localizer).get('LandingPage.LightBuilding.PrivacyPolicy', _unref(routes).UrlPrivacyPolicyLightBuilding)
                        }, null, 8, _hoisted_44),
                        _createElementVNode("div", _hoisted_45, [
                          _createElementVNode("div", _hoisted_46, [
                            _withDirectives(_createElementVNode("input", {
                              type: "checkbox",
                              name: "IsMarketingPolicy",
                              id: "IsMarketingPolicy",
                              "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((formData.value.isMarketingPolicy) = $event))
                            }, null, 512), [
                              [_vModelCheckbox, formData.value.isMarketingPolicy]
                            ]),
                            _createElementVNode("label", _hoisted_47, _toDisplayString(_unref(localizer).get("LandingPage.InfoRequest.PrivacyMarketing")), 1)
                          ])
                        ])
                      ], 8, _hoisted_43),
                      _createElementVNode("fieldset", { disabled: isLoadingForm.value }, [
                        (validationErrors.value.length !== 0)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_49, [
                              _createElementVNode("ul", null, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(validationErrors.value, (validationError, index) => {
                                  return (_openBlock(), _createElementBlock("li", { key: index }, _toDisplayString(validationError.message), 1))
                                }), 128))
                              ])
                            ]))
                          : _createCommentVNode("", true),
                        _createElementVNode("div", _hoisted_50, [
                          _createElementVNode("button", {
                            onClick: _cache[12] || (_cache[12] = ($event: any) => (submitForm())),
                            class: _normalizeClass([{ 'loading': isLoadingForm.value }, 'button'])
                          }, [
                            (!isLoadingForm.value)
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                  _createTextVNode(_toDisplayString(_unref(localizer).get("LandingPage.InfoRequest.SendRequest")), 1)
                                ], 64))
                              : _createCommentVNode("", true)
                          ], 2)
                        ])
                      ], 8, _hoisted_48),
                      _createElementVNode("div", {
                        class: "desc small grecaptcha-terms",
                        innerHTML: _unref(localizer).get('LandingPage.Support.Captcha_Terms')
                      }, null, 8, _hoisted_51)
                    ]),
                    _cache[15] || (_cache[15] = _createElementVNode("img", {
                      src: "/areas/landingpage/images/support-grey.webp",
                      width: "620",
                      height: "772",
                      alt: "Support image",
                      class: "support-image"
                    }, null, -1))
                  ]))
                : _createCommentVNode("", true)
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_52, [
              (!isLoading.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_53, [
                    _createElementVNode("div", _hoisted_54, [
                      _createElementVNode("div", _hoisted_55, _toDisplayString(_unref(localizer).get("LandingPage.InfoRequest.FormSuccessTitleShort")), 1),
                      _createElementVNode("div", _hoisted_56, [
                        _createElementVNode("button", {
                          onClick: _cache[13] || (_cache[13] = ($event: any) => (_unref(store).commit('infoRequestStore/setIsDialogVisible', false))),
                          class: "button"
                        }, _toDisplayString(_unref(localizer).get("LandingPage.InfoRequest.Close")), 1)
                      ])
                    ]),
                    _cache[16] || (_cache[16] = _createElementVNode("img", {
                      src: "/areas/landingpage/images/support-grey.webp",
                      width: "620",
                      height: "772",
                      alt: "Support image",
                      class: "support-image"
                    }, null, -1))
                  ]))
                : _createCommentVNode("", true)
            ]))
      ])
    ])
  ])), [
    [_directive_close_dialog, closeInfoRequest]
  ])
}
}

})